import { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperWdollarsNavigations } from '~/views/molecules/swiper.wdollars.navigations';
import { useService } from '~/services/service.base';
import { ROUTES } from '~/routes/routes';
import { WrapperService } from '~/services/service.wrapper';
import { DialogService } from '~/services/service.dialog';
import { ModelWdollarPackage } from '~/models/model.wdollar.package';
import { WdollarCard } from '~/views/molecules/wdollar.card';
import 'swiper/css';

export const BuyNow: FC = observer(props => {
    const navigate = useNavigate();
    const wrapperService = useService(WrapperService);
    const { paymentService, authService } = wrapperService;
    const dialogService = useService(DialogService);
    const { signInDialogSrv } = dialogService;

    useEffect(() => {
        if (authService.currentUser) {
            paymentService.getWdollarPackages(authService);
        } else {
            paymentService.getPublicWdollarPackages();
        }
    }, [authService.currentUser]);

    const onButtonClickHandler = (item: ModelWdollarPackage, e: any) => {
        if (authService.currentUser) {
            navigate(ROUTES.PAYMENT.path.replace(':id', String(item.id)), { state: { id: item.id } });
        } else {
            signInDialogSrv.handleOpen(e);
        }
    };

    const collapsed = paymentService.showAllMode;

    // when collapsed: show only first 3; otherwise show all
    const packagesToShow = collapsed ? paymentService.wdollarPackages.slice(0, 3) : paymentService.wdollarPackages;

    return (
        <section className="buy-now" id="buy-now">
            <div className="container">
                {/* DESKTOP / TABLET */}
                <div className="buy-now-wrap">
                    {packagesToShow.map((item, idx) => (
                        <WdollarCard key={idx} item={item} onClick={onButtonClickHandler} />
                    ))}
                </div>

                {/* View All / Less toggle */}
                <div className="buy-now-view-wrap">
                    <button id="buy-now-view" type="button" className="btn" onClick={paymentService.handleViewAll}>
                        {/* if collapsed (showing 3), show "View all" */}
                        <span className={collapsed ? '' : 'hide'}>View all</span>
                        {/* if expanded (showing all), show "View Less" */}
                        <span className={!collapsed ? '' : 'hide'}>View Less</span>
                    </button>
                </div>

                {/* MOBILE SWIPER */}
                <div className="buy-now-wrap-mobile">
                    <Swiper
                        className="redeem-amounts-items redeem-slider"
                        spaceBetween={10}
                        slidesPerView={1}
                        onSlideChange={paymentService.handleSlideChange}
                        breakpoints={{
                            1000: { slidesPerView: 3 },
                            700: { slidesPerView: 2.3 },
                            625: { slidesPerView: 2 },
                            450: { slidesPerView: 1 },
                            320: { slidesPerView: 1.2 },
                        }}
                    >
                        <SwiperWdollarsNavigations />
                        {paymentService.wdollarPackages.map((item, idx) => (
                            <SwiperSlide key={idx} className="wdollar-package-item">
                                <WdollarCard item={item} onClick={onButtonClickHandler} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
});
